import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import { initAnalytics, trackPageView } from "./utils/analytics";

const Layout = () => {
    const location = useLocation();

    useEffect(() => {
        initAnalytics();
    }, []);

    useEffect(() => {
        trackPageView(location.pathname + location.search);
    }, [location]);

    // Hide footer if user is logged in or navigating partner portal routes
    const hasToken = !!(
        localStorage.getItem('token_partner_restaurant') ||
        localStorage.getItem('token_partner_shop') ||
        localStorage.getItem('token_partner_activities') ||
        localStorage.getItem('token')
    );

    const isPartnerPortalRoute = 
        location.pathname.startsWith('/restaurant') || 
        location.pathname.startsWith('/shop') || 
        location.pathname.startsWith('/activity');

    const hideFooter = isPartnerPortalRoute || (hasToken && location.pathname !== '/privacy-policy');

    return (
        <div className="flex flex-col min-h-screen">
            <main className="flex-grow">
                <Outlet />
            </main>
            {!hideFooter && <Footer />}
        </div>
    );
};

export default Layout;
